import { render, staticRenderFns } from "./TiendaBodegaComponent.vue?vue&type=template&id=57ea47ce&"
import script from "./TiendaBodegaComponent.vue?vue&type=script&lang=js&"
export * from "./TiendaBodegaComponent.vue?vue&type=script&lang=js&"
import style0 from "./TiendaBodegaComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports